import React from 'react';
import { toast } from 'react-toastify';
import ToastFeedbackMessage from '@/components/common/ToastFeedback/ToastFeedbackMessage';
import ToastFeedbackId from '@/constants/ui/ToastFeedbackId';
import type ToastMessage from '@/types/ToastMessage';

export default function showFeedbackMessage({
  containerId = ToastFeedbackId.APP,
  message,
  type,
}: ToastMessage) {
  return toast(<ToastFeedbackMessage message={message} />, {
    containerId,
    type,
  });
}
